import styled from 'styled-components';

export const ListParent = styled.ul`
  list-style: none;
  margin: 10px 0 30px;
  padding: 0;
`;



// WEBPACK FOOTER //
// ./src/styles/ListParent.js